import React from 'react';
import useScroll from '../../hooks/useScroll';

export default function FloatingActions() {
  const { isVisible } = useScroll(100);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div 
      className={`fixed right-6 bottom-6 z-50 flex flex-col items-end space-y-3 transition-all duration-300 ${
        isVisible ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0 pointer-events-none'
      }`}
      aria-label="Floating contact and scroll shortcuts"
    >
      {/* WhatsApp Chat Button */}
      <a
        href="https://wa.me/918639619079"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="relative group flex items-center justify-center"
      >
        <span className="absolute inset-0 rounded-full bg-green-500/10 animate-ping pointer-events-none" />
        <div className="w-13 h-13 rounded-full nm-button-light flex items-center justify-center text-[#25D366] shadow-md border-transparent">
          <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
            <path d="M20.52 3.48A11.94 11.94 0 0 0 12.02 0C5.4 0 .02 5.38.02 12c0 2.11.55 4.17 1.6 6.01L0 24l6.16-1.6A11.94 11.94 0 0 0 12.02 24C18.64 24 24 18.62 24 12a11.94 11.94 0 0 0-3.48-8.52Zm-8.5 18.44c-1.93 0-3.82-.52-5.47-1.5l-.39-.23-3.65.95.98-3.56-.25-.4A9.9 9.9 0 0 1 2.1 12c0-5.45 4.45-9.9 9.92-9.9a9.9 9.9 0 0 1 9.9 9.9c0 5.47-4.45 9.92-9.9 9.92Zm5.44-7.43c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.34.22-.64.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.5h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.5 1.69.64.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35Z" />
          </svg>
        </div>
        <span className="absolute right-15 bg-slate-900 text-white text-xs px-2.5 py-1 rounded shadow-md opacity-0 group-hover:opacity-100 transition duration-300 pointer-events-none whitespace-nowrap">
          WhatsApp
        </span>
      </a>

      {/* Instagram Button */}
      <a
        href="https://www.instagram.com/cervello_eduverse"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow on Instagram"
        className="relative group flex items-center justify-center"
      >
        <div className="w-13 h-13 rounded-full nm-button-light flex items-center justify-center text-[#FD1D1D] shadow-md border-transparent">
          <svg viewBox="0 0 24 24" className="w-6 h-6" fill="currentColor">
            <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.24 2.22.4a4.4 4.4 0 0 1 1.6.94 4.4 4.4 0 0 1 .94 1.6c.16.42.35 1.05.4 2.22.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.24 1.8-.4 2.22a4.4 4.4 0 0 1-.94 1.6 4.4 4.4 0 0 1-1.6.94c-.42.16-1.05.35-2.22.4-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.24-2.22-.4a4.4 4.4 0 0 1-1.6-.94 4.4 4.4 0 0 1-.94-1.6c-.16-.42-.35-1.05-.4-2.22-.06-1.27-.07-1.65-.07-4.85s.01-3.58.07-4.85c.05-1.17.24-1.8.4-2.22a4.4 4.4 0 0 1 .94-1.6 4.4 4.4 0 0 1 1.6-.94c.42-.16 1.05-.35 2.22-.4 1.27-.06 1.65-.07 4.85-.07Zm0-2.16C8.74 0 8.33.01 7.05.07 5.78.13 4.9.34 4.15.63a6.6 6.6 0 0 0-2.39 1.56A6.6 6.6 0 0 0 .2 4.15C-.09 4.9-.3 5.78-.36 7.05-.42 8.33-.43 8.74-.43 12s.01 3.67.07 4.95c.06 1.27.27 2.15.56 2.9a6.6 6.6 0 0 0 1.56 2.39 6.6 6.6 0 0 0 2.39 1.56c.75.29 1.63.5 2.9.56 1.28.06 1.69.07 4.95.07s3.67-.01 4.95-.07c1.27-.06 2.15-.27 2.9-.56a6.6 6.6 0 0 0 2.39-1.56 6.6 6.6 0 0 0 1.56-2.39c.29-.75.5-1.63.56-2.9.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95c-.06-1.27-.27-2.15-.56-2.9a6.6 6.6 0 0 0-1.56-2.39A6.6 6.6 0 0 0 19.85.63C19.1.34 18.22.13 16.95.07 15.67.01 15.26 0 12 0Zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32Zm0 10.16a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm6.4-10.88a1.44 1.44 0 1 0 0-2.88 1.44 1.44 0 0 0 0 2.88Z" />
          </svg>
        </div>
        <span className="absolute right-15 bg-slate-900 text-white text-xs px-2.5 py-1 rounded shadow-md opacity-0 group-hover:opacity-100 transition duration-300 pointer-events-none whitespace-nowrap">
          Instagram
        </span>
      </a>

      {/* Direct Call Button */}
      <a
        href="tel:+918639619079"
        aria-label="Call phone"
        className="relative group flex items-center justify-center"
      >
        <span className="absolute inset-0 rounded-full bg-blue-500/10 animate-ping pointer-events-none" />
        <div className="w-13 h-13 rounded-full nm-button-light flex items-center justify-center text-[#0B1C2D] shadow-md border-transparent">
          <svg viewBox="0 0 512 512" className="w-5 h-5 text-[#C6A25E]" fill="currentColor">
            <path d="M391.1 351.1c-20.6 0-41.2-3.2-60.8-9.4-9.3-2.9-19.5-.6-26.7 6.5l-37.6 28.3c-54.6-28.9-99-73.3-127.9-127.9l28.3-37.6c7.1-7.1 9.4-17.4 6.5-26.7-6.2-19.6-9.4-40.2-9.4-60.8C163.5 52.1 111.4 0 47.8 0H16C7.2 0 0 7.2 0 16c0 273.9 222.1 496 496 496 8.8 0 16-7.2 16-16v-31.8c0-63.6-52.1-115.7-120.9-115.7z" />
          </svg>
        </div>
        <span className="absolute right-15 bg-slate-900 text-white text-xs px-2.5 py-1 rounded shadow-md opacity-0 group-hover:opacity-100 transition duration-300 pointer-events-none whitespace-nowrap">
          Call Now
        </span>
      </a>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        aria-label="Scroll to top"
        className="w-13 h-13 rounded-full nm-button-light flex items-center justify-center text-[#C6A25E] shadow-md border-transparent focus:outline-none"
      >
        <svg viewBox="0 0 384 512" className="w-5 h-5" fill="currentColor">
          <path d="M169.4 164.7L41.4 292.7c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 233.4l105.4 104.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0z" />
        </svg>
      </button>
    </div>
  );
}
